import { useSelector } from 'store';
import {
  isLoading,
  selectProfileEntityById,
  selectAllProfiles,
  selectAllModifiers,
  selectAppliedTrainings,
  selectModifierEntityById,
  selectAllAppliedProfiles,
} from 'store/selectors/training.selectors';

const TrainingService = {
  useSelectProfiles: () => useSelector(selectAllProfiles),

  useSelectModifiers: () => useSelector(selectAllModifiers),

  useSelectProfileById: (profileId: string) =>
    useSelector((state) => selectProfileEntityById(state, profileId)),

  useSelectModifierById: (modifierId: string) =>
    useSelector((state) => selectModifierEntityById(state, modifierId)),

  useIsLoading: () => useSelector(isLoading),

  useSelectAppliedModifiers: () => useSelector(selectAppliedTrainings),

  useSelectAppliedProfiles: () => useSelector(selectAllAppliedProfiles),
};

export default TrainingService;
